import React__default from 'react';
import _s, { css } from 'styled-components';
import { d as darken } from './darken-303c3324.js';
import Icon from './Icon.js';
import LoadingIndicator from './LoadingIndicator.js';
import './_commonjsHelpers-357b3b4e.js';
import './global-2e5d81b9.js';
import './Box.js';
import './useTheme.js';
import './core.esm-901288dd.js';
import './inheritsLoose-6f2ea841.js';

const backgroundColors = {
  primary: 'secondary',
  secondary: 'transparent',
  'primary-on-image': 'septenary',
  'secondary-on-image': 'transparent',
  social: 'senary',
  outline: 'senary'
};
const colors = {
  primary: 'secondary',
  secondary: 'tertiary',
  'primary-on-image': 'senary',
  'secondary-on-image': 'secondary',
  social: 'primary'
};
const loadingColors = {
  primary: 'senary',
  secondary: 'secondary',
  'primary-on-image': 'primary',
  'secondary-on-image': 'septenary',
  social: 'primary'
};
const borderColors = {
  primary: 'transparent',
  secondary: 'tertiary',
  'primary-on-image': 'transparent',
  'secondary-on-image': 'quaternary',
  social: 'secondary',
  outline: 'quinary'
};
const socialIcons = {
  apple: '24-apple',
  email: '24-envelope',
  facebook: '24-facebook',
  google: '24-google'
};

const styled = typeof _s === "object" && "default" in _s ? _s.default : _s;
const Button = ({
  children,
  disabled = false,
  fullWidth,
  iconTestID,
  loading = false,
  loadingTestID,
  onPress,
  size = 'base',
  socialBrand,
  testID,
  type = 'button',
  variant = 'primary'
}) => {
  return /*#__PURE__*/React__default.createElement(Container, {
    "data-testid": testID,
    disabled: disabled || loading,
    fullWidth: fullWidth,
    onClick: onPress,
    size: size,
    tabIndex: 0,
    type: type,
    variant: variant
  }, loading ? /*#__PURE__*/React__default.createElement(LoadingIndicatorContainer, null, /*#__PURE__*/React__default.createElement(LoadingIndicator, {
    color: loadingColors[variant],
    testID: loadingTestID
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, socialBrand && /*#__PURE__*/React__default.createElement(IconContainer, null, /*#__PURE__*/React__default.createElement(Icon, {
    name: socialIcons[socialBrand],
    testID: iconTestID
  })), children));
};
const Container = styled.button`
  ${({
  theme,
  size,
  variant
}) => css(["margin:0px;justify-content:center;background-color:", ";border-color:", ";border-radius:", "px;border-style:solid;border-width:", "px;color:", ";cursor:pointer;display:flex;font-family:", ";font-size:", "px;font-weight:", ";line-height:", "px;outline:none;padding-bottom:", "px;padding-left:", "px;padding-right:", "px;padding-top:", "px;text-decoration:none;transition:all 0.2s ease;"], theme.shapeFills[backgroundColors[variant]], borderColors[variant] === 'transparent' ? 'rgba(255, 255, 255, 0.01)' : theme.borderColors[borderColors[variant]], theme.borderRadius.base, variant === 'outline' ? theme.borderWidths.base : theme.borderWidths.large, theme.colors[colors[variant]], theme.typographies['label-1'].fontFamily, theme.typographies['label-1'].fontSize, theme.typographies['label-1'].fontWeight, theme.typographies['label-1'].lineHeight, size === 'base' ? theme.spacings.xSmall - theme.borderWidths.large : theme.spacings.tiny - theme.borderWidths.large, theme.spacings.small, theme.spacings.small, size === 'base' ? theme.spacings.xSmall - theme.borderWidths.large : theme.spacings.tiny - theme.borderWidths.large)}

  ${({
  fullWidth
}) => fullWidth && css(["width:100%;"])}

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:hover:enabled,
  &:focus:enabled {
    ${({
  variant,
  theme
}) => {
  if (variant === 'primary' || variant === 'primary-on-image' || variant === 'outline') {
    return css(["background-color:", ";"], darken(0.075, theme.shapeFills[backgroundColors[variant]]));
  }
  if (variant === 'secondary') {
    return css(["background-color:", ";color:", ";"], theme.shapeFills[backgroundColors.primary], theme.colors[colors.primary]);
  }
  if (variant === 'secondary-on-image') {
    return css(["background-color:", ";color:", ";"], theme.shapeFills[backgroundColors['primary-on-image']], theme.colors[colors['primary-on-image']]);
  }
  return undefined;
}}
  }
`;
const IconContainer = styled.div`
  > div {
    ${({
  theme
}) => css(["display:flex;margin-right:", "px;"], theme.spacings.xTiny)}
  }
`;
const LoadingIndicatorContainer = styled.div`
  align-items: center;
  display: flex;
  height: 24px;
  justify-content: center;
`;

export { Button as default };
//# sourceMappingURL=Button.js.map
